import React, { useState, useEffect } from "react";
import { getOnlineUserList } from "../../../services/UserService";
import TableLoaderEffect from "../../constant/TableLoader";
import { Spinner } from "react-bootstrap";

const OnlineUserListPage = () => {
    const [searchQuery, setSearchQuery] = useState("");
    const [data, setData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [isSearchLoading, setIsSearchLoading] = useState(false);

    useEffect(() => {
        setIsLoading(true)
        getOnlineUserList(searchQuery)
            .then((resp) => {
                setData(resp.data.results);
                setIsLoading(false);
                setIsSearchLoading(false)
            })
            .catch((error) => {
                if (error.response) {
                    console.log(error.response.data.message);
                } else {
                    console.log(error);
                }
                setIsLoading(false);
                setIsSearchLoading(false)
            });
    }, [searchQuery]);

    const handleSearchChange = (e) => {
        const { value } = e.target;
        setSearchQuery(value);
        setIsSearchLoading(true)
    };

    function timeAgo(lastLoginDate) {
        // Convert the last login date to a Date object
        const lastLogin = new Date(lastLoginDate);
        
        // Get the current date and time
        const now = new Date();
        
        // Calculate the time difference in milliseconds
        const timeDiff = now - lastLogin;
        
        // Convert the time difference from milliseconds to hours, minutes, and seconds
        const diffInHours = Math.floor(timeDiff / (1000 * 60 * 60));
        const diffInMinutes = Math.floor((timeDiff % (1000 * 60 * 60)) / (1000 * 60));
        const diffInSeconds = Math.floor((timeDiff % (1000 * 60)) / 1000);
        
        // Create an array to hold the time parts
        const timeParts = [];
        
        // Add hours, minutes, and seconds to the array if they are non-zero
        if (diffInHours > 0) {
          timeParts.push(`${diffInHours} hrs`);
        }
        if (diffInMinutes > 0) {
          timeParts.push(`${diffInMinutes} min`);
        }
        if (diffInSeconds > 0) {
          timeParts.push(`${diffInSeconds} sec`);
        }
        
        // Join the time parts into a single string
        const timeString = timeParts.join(' ');
        
        // Return the formatted string, or a default message if all parts are zero
        return timeString ? `${timeString} ago.` : 'just now.';
      }
      
      
      
      
    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-xl-12">
                        <div className="card">
                            <div className="card-body p-0">
                                <div className="tbl-caption d-flex justify-content-between text-wrap flex-column  flex-sm-row align-items-start align-items-sm-center p-3">
                                    <h4 className="heading mb-3 mb-md-0 fw-bold">ONLINE USER</h4>
                                    <div className="d-flex align-items-start align-items-sm-center flex-column flex-sm-row">
                                        <div className="me-3 mb-3 mb-md-0">
                                            <div className="input-group tp-input-group">
                                                <input
                                                    type="text"
                                                    className="form-control"
                                                    placeholder="Search"
                                                    value={searchQuery}
                                                    aria-describedby="basic-search"
                                                    onChange={handleSearchChange}
                                                />
                                                <div className="input-group-text" id="basic-search">
                                                    {isSearchLoading && (
                                                        <Spinner variant="primary" size="sm" />
                                                    )}
                                                    {!isSearchLoading && searchQuery.length > 0 && (
                                                        <i
                                                            className="fa-solid fa-xmark c-pointer text-primary"
                                                            onClick={() => {
                                                                setSearchQuery("");
                                                            }}
                                                        ></i>
                                                    )}
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="table-responsive active-projects style-1 ItemsCheckboxSec shorting">
                                    <div
                                        id="employee-tbl_wrapper"
                                        className="dataTables_wrapper no-footer"
                                    >
                                        <table
                                            id="empoloyees-tblwrapper"
                                            className="table ItemsCheckboxSec dataTable no-footer mb-0 table-striped"
                                        >
                                            <thead>
                                                <tr>
                                                    <th>Personnel No.</th>
                                                    <th>Full Name</th>
                                                    <th>Designation</th>
                                                    <th>Department</th>
                                                    <th>Last Login</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {isLoading ? (
                                                    <TableLoaderEffect colLength={5} />
                                                ) : (
                                                    data.map((item, index) => (
                                                        <tr key={index}>
                                                            <td>
                                                                <span>
                                                                    {item.personnel_number}
                                                                </span>
                                                            </td>
                                                            <td>
                                                                <span>{item.full_name}</span>
                                                            </td>
                                                            <td>
                                                                <span>{item.designation}</span>
                                                            </td>
                                                            <td>
                                                                <span>{item.department}</span>
                                                            </td>
                                                            <td>
                                                                <span>{timeAgo(item.last_login)}</span>
                                                            </td>
                                                        </tr>
                                                    ))
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default OnlineUserListPage;
